import {http} from "../util/http"
import {API_KOTLIN_DOMAIN} from "../config"
import {AxiosPromise} from "axios"

/**
 * @typedef  MeiTuanResponse
 * @template T
 * @property {number} status
 * @property {string} detail
 * @property {T} data
 */


/**
 *  @typedef  MeiTuanPlatformType
 * @property {object} platform
 * @property {number} platform.clubId
 * @property {number} platform.order
 * @property {string} platform.name
 * @property {number} platform.id
 * @property {boolean} platform.isConsumable
 * @property {boolean} platform.isEnabled
 * @property {string} platform.createTime
 * @property {string} platform.updateTime
 * @property {object} value
 * @property {object} value.merchant
 * @property {string} value.merchant.platformMerchantId
 * @property {string} value.merchant.name
 * @property {number} value.merchant.id
 * @property {string} value.merchant.createTime
 * @property {string} value.merchant.updateTime
 * @property {object} value.shop
 * @property {number} value.shop.merchantId
 * @property {string} value.shop.platformShopId
 * @property {string} value.shop.name
 * @property {string} value.shop.createTime
 * @property {string} value.shop.updateTime
 * @property {number} value.shop.id
 */


/**
 * 获取团购平台商户
 * @param platformId {number|null}
 * @return {MeiTuanResponse<MeiTuanPlatformType[]>}
 */
export const fetchRelationStore = async (platformId = null) => {
    const params = {
        clubId: sessionStorage.getItem('club_id'),
    }
    if (platformId) {
        params.platformId = platformId
    }

    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/platform/merchant`,
        method: 'get',
        params: params
    })

}

/**
 * 获取授权地址
 * @param platformId {number} 平台id
 * @return {MeiTuanResponse<{authUrl:string,state:string}>}
 */
export const fetchAuthorizeUrl = async (platformId) => {
    const clubId = sessionStorage.getItem('club_id')
    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/platform/merchant/redirectUrl`,
        method: 'get',
        params: {
            clubId,
            platformId
        }
    })
}


/**
 * 刷新授权
 * @param merchantId 美团门店id
 * @returns {AxiosPromise<MeiTuanResponse>}
 */
export const refreshAccessToken = async (merchantId) => {
    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/meiTuan/merchant/refreshToken`,
        method: 'post',
        data: {
            merchantId
        }
    })
}

/**
 *解绑门店
 * @param platformId 美团门店id
 */
export const unbindMerchant = async (platformId) => {
    const clubId = sessionStorage.getItem("club_id")
    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/platform/merchant/unbind`,
        method: "post",
        data: {
            clubId,
            platformId
        }
    })
}

/**
 * 获取商户列表
 * @param platformId 美团门店id
 * @param merchantId 商户id
 */
export const fetchShopList = async (platformId, merchantId) => {
    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/platform/shop`,
        method: 'get',
        params: {
            platformId,
            merchantId
        }
    })
}

/**
 * 绑定商户
 * @param platformId {number}
 * @param shop {{openShouUuip:string,shopName:string}}
 */
export const bindShop = async (platformId, shop) => {
    const clubId = sessionStorage.getItem('club_id')
    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/platform/shop/bind`,
        method: 'post',
        data: {
            platformId,
            clubId,
            shop
        }
    })
}

/**
 * 解绑商户
 * @param platformId {number}
 */
export const unbindShop = async (platformId) => {
    const clubId = sessionStorage.getItem("club_id")
    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/platform/shop/unbind`,
        method: 'post',
        data: {
            platformId,
            clubId
        }
    })
}

/**
 * 抖音绑定
 * @param douYinShopId {number}
 */

export const douYinBind = async (douYinShopId) => {
    const clubId = sessionStorage.getItem("club_id")
    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/douYin/merchant/bind`,
        method: 'post',
        data: {
            clubId,
            accountId: douYinShopId
        }
    })
}

/**
 * 触发绑定小智店铺
 */
export const bindXiaoZhiShop = async () => {
    const clubId = sessionStorage.getItem('club_id')
    return http({
        url: `${API_KOTLIN_DOMAIN}/club/groupon/xiaoZhi/shop/bind`,
        method: 'post',
        data: {
            clubIds: [clubId],
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/clubPlatform.js